import React from 'react';
import { tileFaceMarkup } from './tileFaces';

/* Renders one tile's printed face.
 *
 * The artwork lives in tileFaces.js as a markup string so the static design
 * harness can require the same module through node — one definition of the 27
 * faces instead of two that drift. That is why this uses
 * dangerouslySetInnerHTML: the markup is assembled from a suit letter and an
 * integer 1-9 that tileFaceMarkup validates, with nothing from the server or
 * the player reaching it, so there is no injection surface.
 *
 * No frame or background here. .t-tile supplies the bone face and the
 * crystalline bevel; this draws only what is printed on it.
 */
export default function TileGraphic({ tile }) {
  if (!tile) return null;
  const markup = tileFaceMarkup(tile.suit, tile.value);
  if (!markup) return null;
  return (
    <span
      className="tile-face"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}
